/**
 * SKU の当日発送可能性。
 *
 * server が SKU 単位で判定した結果（`/api/user/cart*` の `productDetail.sameDayShipping`）を client 内部で扱う型。
 * - `available`: 可能。注文締切日時つき
 * - `unknown`: server が判定したが、可能と言い切れない。Front は不可能と断言できる立場になく、可能と言えないものはここに落ちる
 * - `notEvaluated`: server の判定を経ていない。client 専用の状態で、server のレスポンスには現れない。
 *   注文完了画面をカートでなく注文履歴モデルで描画する対応（https://github.com/Everforth/growthpalette-front/issues/8877）で、
 *   この状態を置く経路ごと不要になる想定
 *
 * `orderDeadlineAt` はレスポンス時点の「当日」の締切であり、取得後に過ぎることも、取得時点で既に過ぎていることもある。
 * 締切を過ぎたかどうかは、利用側が現在時刻と比較して判断する。
 */
export type SameDayShippingAvailability =
  | { readonly status: 'available', readonly orderDeadlineAt: Date }
  | { readonly status: 'unknown' }
  | { readonly status: 'notEvaluated' }

export const unknownSameDayShipping: SameDayShippingAvailability = { status: 'unknown' }

export const notEvaluatedSameDayShipping: SameDayShippingAvailability = { status: 'notEvaluated' }

export function availableSameDayShipping(orderDeadlineAt: Date): SameDayShippingAvailability {
  return { status: 'available', orderDeadlineAt }
}
